import { Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { useAuthStore } from "@/lib/auth-store";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { PaginaLoader } from "@/components/shared/PaginaLoader";

export function AdminRoute() {
  const gebruiker = useAuthStore((s) => s.gebruiker);
  const { t } = useTranslation();

  // ProtectedRoute (de ouder) laadt de gebruiker en toont intussen zelf een
  // loader. Is de stand hier tóch nog leeg (bv. profiel-query faalde zonder
  // 401), dan wachten we; nooit routeren op een halfgeladen auth-stand.
  if (!gebruiker) return <PaginaLoader />;

  if (gebruiker.rol !== "admin") {
    return (
      <div className="py-20 flex justify-center">
        <Card className="max-w-md">
          <CardHeader>
            <CardTitle>{t("algemeen.geen_toegang")}</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <p className="text-sm text-muted-foreground">
              {t("algemeen.geen_toegang_uitleg")}
            </p>
            <Button asChild variant="outline">
              <a href="/">{t("algemeen.naar_dashboard")}</a>
            </Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  return <Outlet />;
}
